/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/optionbox/optionbox.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js